import React from "react";
import "./about-us.scss";
import contractLogo from "../images/simple-setup.svg";
import creditLogo from "../images/credit.svg";
import paymentLogo from "../images/payment-method.svg";
import loanTrackerLogo from "../images/tracker.svg";

const gridItems = [
  {
    img: contractLogo,
    heading: "Simple Setup",
    text: "Your time is precious, so we make it quick and easy to create a personalized account.",
  },
  {
    img: creditLogo,
    heading: "Building Credit",
    text: "On-time payments lower your balance and increase your credit score. We call that a win-win.",
  },
  {
    img: paymentLogo,
    heading: "Payment Portal",
    text: "Our secure system puts you in charge, letting you choose between recurring or one-time payments.",
  },
  {
    img: loanTrackerLogo,
    heading: "Loan Tracker",
    text: "Review past payments and see your remaining loan balance details all in one place.",
  },
];

type GridItem = {
  img: string;
  heading: string;
  text: string;
};

function AboutUs() {
  return (
    <section className="about-us">
      <p className="cta-text">
        We believe that car buying should be simple and inviting. Which is why
        we partner with local dealerships to streamline funding and find
        affordable auto financing solutions designed for you. Once behind the
        wheel, we’ll be with you every mile of your journey.
      </p>
      <ul className="about-us__grid">
        {gridItems.map((item: GridItem) => (
          <li key={item.heading} className="about-us__grid-item">
            <img src={item.img} alt="" />
            <div>
              <div className="heading">{item.heading}</div>
              <p>{item.text}</p>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default AboutUs;
